<template>
	<div class="not-found page_content">
		<h1>404</h1>
		<p>接口服务错误!</p>
		<router-link to="/">返回首页</router-link>
	</div>
</template>

<script>
export default {
	name: 'NotFound',
};
</script>

<style scoped>
.not-found {
	text-align: center;
}
</style>